import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

export function createNewsletterMutations(client: StoxlyClient) {
  return {
    subscribe: {
      mutationFn: (body: Body<'newsletterSubscribe'>) => client.newsletterSubscribe(body),
    },
  };
}
